<div *ngIf="!segmentsLength; else userOptList" class="alc-grey-frame">
  <span translate="segments/no-segment"></span>

  <button
    mat-raised-button
    type="button"
    (click)="redirectToNewSegment()"
    color="primary"
    class="add-segment-button"
    translate="segments/create"
    aria-label="create"></button>
</div>

<ng-template #userOptList>
  <mat-tab-group
    mat-align-tabs="start"
    [selectedIndex]="selectedTabIndex"
    (selectedIndexChange)="selectedTabChanged($event)">
    <mat-tab>
      <ng-template matTabLabel>{{ 'audience/tabs/optins' | translate }}</ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template matTabLabel>{{ 'audience/tabs/optouts' | translate }}</ng-template>
    </mat-tab>
    <mat-tab
      disabled
      *ngIf="{
        statistics: statisticsBS.value,
        tab: selectedTabIndex === 1 ? 'optouts' : 'optins'
      } as result">
      <ng-template matTabLabel>
        {{ result.statistics[result.tab].retrieved }} / {{ result.statistics[result.tab].total }}
      </ng-template>
    </mat-tab>
  </mat-tab-group>
  <div class="table-wrapper" *ngIf="dataSource">
    <cdk-virtual-scroll-viewport
      tvsItemSize="48"
      class="wrapper"
      [style.height.px]="maxHeight"
      (scroll)="fetchUsers.emit({ scrollEvent: $event, selectedTabIndex })">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>
            <span>ID</span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.id }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="account_name">
          <th mat-header-cell *matHeaderCellDef>
            <span translate="audience/account_name"></span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.account_name }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="external_id">
          <th mat-header-cell *matHeaderCellDef>
            <span translate="audience/social_id"></span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.external_id }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            <span translate="audience/social_name"></span>
          </th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="element.is_test">
              <span class="testing-badge">
                {{ 'mass_messaging/testing-flag' | translate }}
              </span>
              &nbsp;
            </ng-container>
            <span>{{ element.name }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="real_name">
          <th mat-header-cell *matHeaderCellDef>
            <span translate="audience/real_name"></span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.real_name }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="is_vip">
          <th mat-header-cell *matHeaderCellDef>
            <span translate="segments/edition/condition-types/vip"></span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.isVipLabel }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="user_optin_date">
          <th mat-header-cell *matHeaderCellDef>
            <span translate="audience/optin_date"></span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.user_optin_date | dateTimezone: 'shortDate' }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="gdpr_optout_date">
          <th mat-header-cell *matHeaderCellDef>
            <span translate="audience/gdpr_optout_date"></span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.gdpr_optout_date | dateTimezone: 'shortDate' }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="optout_date">
          <th mat-header-cell *matHeaderCellDef>
            <span translate="audience/optout_date"></span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.optout_date | dateTimezone: 'shortDate' }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="optout_reason">
          <th mat-header-cell *matHeaderCellDef>
            <span translate="audience/optout_reason"></span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.optout_reason }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="last_message_language">
          <th mat-header-cell *matHeaderCellDef>
            <span translate="audience/last_message_language"></span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.last_message_language | translate }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="is_active_for_period">
          <th mat-header-cell *matHeaderCellDef>
            <div>
              <span translate="audience/is_active_for_period_2"></span>
              <mat-icon [matTooltip]="'audience/is_active_for_period_tooltip' | translate">help</mat-icon>
            </div>
          </th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.isActiveForPeriodLabel }}</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            <span
              *ngIf="!hasFilters && segmentsLength; else noResult"
              translate="search/no_selected_params_text"></span>
            <ng-template #noResult>
              <span translate="audience/no-results"></span>
            </ng-template>
          </td>
        </tr>
      </table>
    </cdk-virtual-scroll-viewport>
  </div>
</ng-template>
